import React, { useEffect, createElement } from 'react';
export function MetaPixel() {
  useEffect(() => {
    const pixelId = '26257470350562748';
    const w = window as any;
    if (!w.fbq) {
      const n: any = function (...args: any[]) {
        n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
      };
      w.fbq = n;
      if (!w._fbq) w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      // Append the loader script to <head> instead of relying on an existing
      // <script> tag being present (which can be undefined in some envs).
      const t = document.createElement('script');
      t.async = true;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const parent = document.head || document.getElementsByTagName('head')[0] || document.body;
      if (parent) parent.appendChild(t);
    }
    w.fbq('init', pixelId);
    w.fbq('track', 'PageView');
  }, []);
  return <noscript data-id="element-103">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=26257470350562748&ev=PageView&noscript=1" alt="" data-id="element-104" />
    </noscript>;
}